import { Spin, Table } from 'antd';
import { styled } from 'styled-components';
import LoadingError from '../../ui/error/LoadingError';
import { Excel } from 'antd-table-saveas-excel';
import DownloadButton from '../../ui/DownloadButton';

const NonSlrTable = (props) => {
    const { dataSource, isError, isLoading } = props;

    let nullColumns = [];
    if(dataSource.length) {
      nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
    }
    console.log(nullColumns)

    const columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (_, { date }) => date && date
      },
      {
        title: 'Product',
        dataIndex: 'product',
        key: 'product',
      },
      {
        title: 'Bid',
        dataIndex: 'bid',
        key: 'bid',
      },
      {
        title: 'Ask',
        dataIndex: 'ask',
        key: 'ask',
      },
      {
        title: 'Tenure',
        dataIndex: 'tenor',
        key: 'tenor',
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
        key: 'rate',
      },
      {
        title: 'CPCD',
        dataIndex: 'iscpcd',
        key: 'iscpcd',
        render: (_, isCpcd) => isCpcd ? 'Yes' : 'No',
      },
      {
        title: 'Updated on',
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (_, { updated_on }) => updated_on && updated_on
      },
    ].filter((item) => !nullColumns.includes(item.key));

    function excelExportHandler() {
      const excel = new Excel();
      excel.addSheet("Sheet 1")
      .addColumns(columns)
      .addDataSource(dataSource, { str2Percent: true })
      .saveAs("MarketPrice.xlsx");
    }

  if(isLoading) return (
    <Spin 
        tip="Loading" 
        size="large" 
        className='loading-spiner'
    />
  );
  if(isError) return <LoadingError />;

  return (
      <Wrapper>
          <DownloadButton onClick={excelExportHandler}>Export</DownloadButton>
          <div className='card'>
              <Table 
              dataSource={dataSource}
              bordered
              size='small'
              columns={columns} 
              style={{
                  marginTop: '10px',
                  padding: 0,
              }}
              // scroll={{ x: 1200 }}
              />
          </div>
      </Wrapper>
  );
}

export default NonSlrTable;

const Wrapper = styled.div`
    /* width: 95%;
    margin: auto; */
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;

